import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import { JustWinDialog } from 'Components/Modals/Investment/JustWinDialog/JustWinDialog';

const Picker = ({ meetingResource, onClose }) => {
  return pick(meetingResource, {
    [fr.relationships.justWinPM1.name]: <JustWinDialog onClose={onClose} justWinRelationship={meetingResource.relationship(fr.relationships.justWinPM1.name)} />,
    [fr.relationships.justWinPM2.name]: <JustWinDialog onClose={onClose} justWinRelationship={meetingResource.relationship(fr.relationships.justWinPM2.name)} />,
  }, null);
};

export { Picker };
